<div class="main-container">
  <app-replay-progress
    [progressEvent]="progressEvent()"
    [totalSegments]="totalSegments()"
    class="replay-progress"
  />

  <div class="replay-controls-container">
    <app-playback-button [icon]="playIcon()" (clickEvent)="playClick()" class="playback-button" />
    <app-playback-button icon="back" (clickEvent)="skipBackClick()" class="playback-button" />
    <app-playback-button icon="next" (clickEvent)="skipForwardClick()" class="playback-button" />

    <button (click)="playbackSpeedClick()" class="playback-speed-button">
      <span [ngStyle]="labelStyles | theme">{{ playbackSpeed() }}</span>
    </button>
  </div>
</div>
